<template>
  <div class="mains">
    <div class="campus">
      功能模块
      <span>></span>
      <span @click="listeningear0">磨耳朵</span>
      <span>></span>
      <router-link to>上传音频</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="xiaoqu_1">上传音频</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>“磨耳朵”
          模块所上传的最终结果会根据您所排列的顺序展现在小程序的磨耳朵功能部分。
        </div>
        <div class="form_1">
          <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
            <el-form-item label="名称" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lianzi1" />
              </i>
              <el-input v-model="form.name" placeholder="请输入校区名称 ( 不超过12字 )" :disabled="this.show" @blur="blur" @keyup.enter.native="$event.target.blur"></el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="updateChapter1">
                  重命名
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="排序" prop="seqnum">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lianzi1" />
              </i>
              <el-input v-model="form.seqnum" placeholder="请输入排序 ( 阿拉伯数字 )" :disabled="this.show1" @blur="blur_seq" @keyup.enter.native="$event.target.blur"></el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="updateChapter2">
                  重置
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="上传音频" class="shangchuan_bg1" prop="orgcode">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.orgcode" placeholder="请输入您上传的音频名称" @keyup.enter.native="handleAvatarSuccess"></el-input>
              <el-upload class=" shangchuan_yinyue" action="#" :show-file-list="false" :disabled="disabled1" :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <el-button type="primary" class="my-10" @click="daoru_add">
                  导入音频
                </el-button>
              </el-upload>
            </el-form-item>

            <el-form-item label prop="orgcode" class="shangchuan_bg">
              <div class="grid-content">
                <div class="zsbg">
                  <el-table :data="tableData" border style="width: 62.8125vw">
                    <el-table-column prop="title" label="音频名称" max-width="360">
                      <template slot-scope="scope1">
                        <!-- {{ scope1.row.title }} -->
                        <input type="text" class="yp_name" :class="scope1.row.selected ? 'yp_name2' : 'yp_name1'" v-model="scope1.row.title" :disabled="scope1.row.selected" :id="scope1.row.selected ? '' : 'inputId'"
                          @blur="blur1(scope1.$index, tableData)" @keyup.13="blur1(scope1.$index, tableData)" />
                      </template>
                    </el-table-column>
                    <el-table-column prop="orgcode" label>
                      <template slot-scope="scope">
                        <div style="width: 100%; height: 32px">
                          <audio controls controlsList="nodownload" style="width: 100%; height: 100%" :src="scope.row.audio_url"></audio>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="音频排序">
                      <template slot-scope="scopes">
                        <el-input v-model="scopes.row.seqnum" class="yp_paixu" @blur="blur1(scopes.$index, tableData)" @keyup.enter.native="
                            $event.target.blur(scopes.$index, tableData)
                          "></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="stData">
                        <el-button type="text" @click="chong(stData.$index, tableData)">
                          重命名
                        </el-button>
                        <el-button type="text" @click="deleteListen(stData.row.id)">
                          删除音频
                        </el-button>
                        <el-upload style="margin-left: 0.52083vw; display: inline" action="#" :show-file-list="false" :http-request="handleAvatarSuccesss" :before-upload="beforeAvatarUpload">
                          <el-button type="text" @click="genghuan(stData.row.id)">更改音频</el-button>
                        </el-upload>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'listeningear',
  data() {
    return {
      form: {
        name: '',
        orgcode: '',
        seqnum: '',
      },
      FormRules: {},
      show: true,
      show1: true,
      disabled1: true,
      tempImg: '',
      banji_id: {},
      tableData: [],
      gh_yp: '',
    };
  },
  created() {
    if (!this.$store.state.listening) {
      this.$router.push({ name: 'listening' });
      return this.$message.error('您当前的章节数据获取失败！');
    }
    this.banji_id = this.$store.state.listening;

    this.selectListeningList();
    this.selctChapterandsectionById();
  },
  destroyed() {
    localStorage.removeItem('listening');
  },
  watch: {},
  methods: {
    listeningear0() {
      this.$store.commit('listeningear0', this.banji_id.bookid);
      this.$router.push({ name: 'listening' });
    },
    beforeAvatarUpload(file) {
      const flieArr = file.name.split('.');
      const isMP3 = flieArr[flieArr.length - 1] === 'mp3';
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isMP3) {
        this.$message.error('上传音频只能是 MP3 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 100MB!');
        return false;
      }
      return isMP3 && isLt2M;
    },
    // 章节重命名
    updateChapter1() {
      this.show = false;
    },
    updateChapter2() {
      this.show1 = false;
    },
    blur() {
      this.show = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/chapterandsection/updateChapter',
        method: 'POST',
        data: {
          id: this.banji_id.id,
          title: this.form.name,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          return this.$message.success('章节重命名成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('章节重命名失败：' + err);
        });
    },
    blur_seq() {
      this.show1 = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/chapterandsection/updateChapter',
        method: 'POST',
        data: {
          id: this.banji_id.id,
          seqnum: this.form.seqnum,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          return this.$message.success('顺序重设成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('顺序重设失败：' + err);
        });
    },

    // 音频重命名
    chong(index, rows) {
      // console.log(index)
      // console.log(rows[index])
      rows[index].selected = false;
      document.getElementById('inputId').focus();
      // this.$refs.id.focus()
    },
    blur1(index, rows) {
      // console.log(rows[index])
      rows[index].selected = true;

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/listen/updateListen',
        method: 'POST',
        data: {
          id: rows[index].id,
          title: rows[index].title,
          seqnum: rows[index].seqnum,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.selectListeningList();
          return this.$message.success('音频修改成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('音频修改失败：' + err);
        });
    },

    // 上传音频
    handleAvatarSuccess(data) {
      // console.log(data)
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();

      formData.append('file', data.file);
      formData.append('orgid', orgid);
      formData.append('bookid', this.banji_id.bookid);
      formData.append('chapterid', this.banji_id.id);
      formData.append('title', this.form.orgcode);

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/listen/uploadAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.selectListeningList();
          this.form.orgcode = '';
          this.$message.success('上传音频成功！');
        })
        .catch((err) => {
          this.$message.error('上传音频错误：' + err);
        });
    },
    daoru_add() {
      if (this.form.orgcode === '') {
        this.disabled1 = true;
        return this.$message.error('请首先输入该音频的名称！');
      } else {
        this.disabled1 = false;
      }
    },

    // 更改音频
    genghuan(id) {
      // console.log(id)
      this.gh_yp = id;
    },
    handleAvatarSuccesss(data) {
      // console.log(data)
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();

      formData.append('file', data.file);
      formData.append('orgid', orgid);
      formData.append('bookid', this.banji_id.bookid);
      formData.append('chapterid', this.banji_id.id);
      formData.append('id', this.gh_yp);
      // console.log(formData)

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/listen/updateAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.selectListeningList();
          this.$message.success('更改音频成功！');
        })
        .catch((err) => {
          this.$message.error('更改音频错误：' + err);
        });
    },

    // 删除音频
    deleteListen(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/listen/deleteListen/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.selectListeningList();
            return this.$message.success('删除音频成功!');
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error('删除音频失败：' + err);
          });
      });
    },

    // 查询章节名称
    selctChapterandsectionById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/chapterandsection/selctChapterandsectionById/' + this.banji_id.id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.form.name = result.data.data.title;
          this.form.seqnum = result.data.data.seqnum;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询章节名称失败：' + err);
        });
    },

    // 查询音频
    selectListeningList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/listen/selectListeningList',
        method: 'POST',
        data: {
          bookid: this.banji_id.bookid,
          chapterid: this.banji_id.id,
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].selected = true;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询音频列表失败：' + err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
audio:focus {
  outline: none;
}
.yp_paixu {
  input {
    width: 44px !important;
    height: 25px !important;
  }
  .el-input__inner {
    padding: 0 !important;
    margin: 0 !important;
    margin: 0 auto;
    text-align: center;
  }
}
.yp_name {
  margin-left: 0 !important;
  font-size: 16px;
  color: #666;
  width: 140px !important;
  height: 1.6vw !important;
  padding-left: 10px;
  background: none;
  position: relative;
  left: -10px;
  border: none;
}
.yp_name1 {
  border: #00a6e6 1px solid;
}
.yp_name2 {
  border: none;
}
.yp_name:focus {
  border: #00a6e6 1px solid;
  outline: none;
}

.shangchuan_bg1 {
  margin: 0 !important;
}
.shangchuan_bg {
  margin: 0 !important;
  .el-form-item__content {
    margin: 0 !important;
    .grid-content {
      padding: 0 0.6vw;
      .zsbg {
        margin: 0 0 45px 0;
        .el-table th {
          background: #f7f7f7;
        }
      }
    }
  }
}
</style>
